import { createRouter, createWebHashHistory } from 'vue-router'
import Home from '../views/layout/SystemLayout.vue'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    redirect: '/index',
    children: [
      {
        path: '/index',
        name: 'Index',
        meta: { title: '首页', icon: 'IndexPage', hideFooter: true },
        component: () => import('@/views/content/IndexPage')
      },
      {
        path: '/resume',
        name: 'Resume',
        meta: { title: '简历制作', icon: 'SnippetsOutlined' },
        component: () => import('@/views/content/Resume')
      },
      {
        path: '/templatePage',
        name: 'templatePage',
        meta: { title: '模版广场', icon: '', hideFooter: true , showAllrightFooter: true},
        component: () => import('@/views/content/templatePage')
      },
      {
        path: '/aiCreate',
        name: 'aiCreate',
        meta: { title: 'AI生成简历', icon: '', hideFooter: true, showAllrightFooter: true},
        component: () => import('@/views/content/aiCreate')
      },
      {
        path: '/beforePreView',
        name: 'beforePreView',
        meta: { title: '简历模板详情', icon: '', hideFooter: true, showAllrightFooter: true},
        component: () => import('@/views/content/beforePreView')
      }
    ]
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router
